import { Component, OnInit } from "@angular/core";
import { Injectable, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  UntypedFormBuilder,
} from "@angular/forms";

import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { DaoService } from "./../../services/dao.service";
import { Router } from "@angular/router";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { UserdeleteComponent } from "../userdelete/userdelete.component";
import { ToastService } from "src/app/services/toast.service";
import { MatSort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "app-attribute-list",
  templateUrl: "./attribute-list.component.html",
  styleUrls: ["./attribute-list.component.scss"],
})
export class AttributeListComponent implements OnInit {
  dataSource: any;
  attributeList: any;
  entity: any;
  pageEvent: PageEvent;
  private paginator: MatPaginator;
  // tslint:disable-next-line: variable-name
  public created_By: any;
  displayedColumns: string[] = ["Sno", "entityType", "name", "edit", "delete"];
  public validator = {
    errorMessage: "",
    UniqueAttribute: false,
    isCorrelation: false,
  };
  public shown = {
    grid: true,
    Form: false,
  };

  public attributeEdit = {
    edit: false,
  };
  isShowInfos: any;

  Attribute = new FormGroup({
    attributeId: new FormControl(),
    name: new FormControl(),
    uiName: new FormControl(),
    entityType: new FormControl(),
    dataType: new FormControl(),
    isShowInfo: new FormControl(),
    isShowAlgo: new FormControl(),
    isUnique: new FormControl(),
    isCustom: new FormControl(),
    correlationValue: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  pageIndex: number;
  pageSize: number;
  length: number;
  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
  }
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  constructor(
    private router: Router,
    private daoService: DaoService,
    private fromBuilder: UntypedFormBuilder,
    private token: LstorageService,
    private spinner: SpinnerService,
    public dialog: MatDialog,
    private toast: ToastService
  ) {}
  ngOnInit() {
    this.spinner.show();
    this.created_By = jwtDecode(this.token.getToken());
    this.Attribute = this.fromBuilder.group({
      attributeId: [""],
      name: [""],
      uiName: ["", [Validators.required]],
      entityType: [""],
      dataType: ["1001"],
      isShowInfo: [""],
      isShowAlgo: [""],
      isUnique: [""],
      isCustom: [""],
      correlationValue: [""],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: [""],
      modifiedBy: [""],
      modifiedOn: [""],
    });

    this.daoService.getAttributeList().subscribe(
      (data: any) => {
        this.daoService.defaultAttributeList(data);
        this.daoService.finalattributeList.subscribe(
          (attributeList) => (this.attributeList = attributeList)
        );
        this.dataSource = new MatTableDataSource(this.attributeList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log("Error: " + error);
      }
    );
    // this.daoService.getEntity().subscribe((data) => {
    //   this.entity = data;
    // });
    this.daoService.getEntities().subscribe((data) => {
      this.entity = data;
    });
  }

  setDataSourceAttributes() {
    this.setDataSourceAttributes();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  // Form
  AttributeForm() {
    this.attributeEdit.edit = false;
    this.shown.grid = false;
    this.shown.Form = true;
    this.Attribute = this.fromBuilder.group({
      attributeId: [""],
      uiName: [""],
      name: ["", [Validators.required]],
      entityType: [""],
      dataType: ["1001"],
      isShowInfo: [false],
      isShowAlgo: [false],
      isUnique: [false],
      isCustom: [false],
      correlationValue: [0],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2019-11-05T17:04:56.351Z"],
      modifiedBy: [""],
      modifiedOn: ["2019-11-05T17:35:10.052Z"],
    });
  }

  createAttribute() {
    this.spinner.show();
    this.validator.UniqueAttribute = false;
    this.validator.isCorrelation = false;
    if (this.Attribute.value.isShowAlgo) {
      if (this.Attribute.value.correlationValue == 0) {
        this.validator.isCorrelation = true;
        this.spinner.hide();
      } else {
        this.daoService.AddAttribute(this.Attribute.value).subscribe(
          (data: any) => {
            this.spinner.hide();
            this.toast.openSnackBar("Attribute added successfully", "close");
            this.backattributeList();
          },
          (error) => {
            console.log(error);
            this.spinner.hide();
            this.validator.UniqueAttribute = true;
            this.validator.errorMessage = error.error.userMessage;
          }
        );
      }
    } else {
      this.daoService.AddAttribute(this.Attribute.value).subscribe(
        (data: any) => {
          this.toast.openSnackBar("Attribute added successfully", "close");
          this.backattributeList();
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
          this.validator.UniqueAttribute = true;
          this.validator.errorMessage = error.error.userMessage;
        }
      );
    }
  }
  editAttribute(id) {
    this.shown.grid = false;
    this.shown.Form = true;
    this.attributeEdit.edit = true;
    this.daoService.getAttributeById(id).subscribe((data: any) => {
      this.Attribute = this.fromBuilder.group({
        attributeId: [id],
        entityType: [data.entityType, [Validators.required]],
        name: [data.name, [Validators.required]],
        uiName: [data.uiName],
        isShowInfo: [data.isShowInfo],
        isShowAlgo: [data.isShowAlgo],
        isUnique: [data.isUnique],
        isCustom: [data.isCustom],
        correlationValue: [data.correlationValue],
        modifiedBy: [this.created_By.unique_name],
      });
    });
  }

  //DeleteAttribut
  deleteAttribute(id) {
    this.daoService.defaultAttributeId(id);
    this.daoService.attributeDelete(true);
    const dialogRef = this.dialog.open(UserdeleteComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "376px",
      height: "145px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.attributeDelete(false);
      this.daoService.finalattributeList.subscribe(
        (attributeList) => (this.attributeList = attributeList)
      );
      this.dataSource = new MatTableDataSource(this.attributeList);
      this.daoService.defaultAttributeId(null);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter((l_cur_row) => {
      return l_cur_row[p_key] != p_value_to_remove;
    });
  }

  backattributeList() {
    this.shown.grid = true;
    this.shown.Form = false;
    this.validator.UniqueAttribute = false;
    this.daoService.getAttributeList().subscribe((data: any) => {
      this.attributeList = data;
      this.dataSource = new MatTableDataSource(this.attributeList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  attributeFilter = (value: string) => {
    this.dataSource.filter = value;
  };

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    if (this.Attribute.value.correlationValue.length > 2) {
      return false;
    }

    return true;
  }

  //For store pagination details
  public handlePage(e: any) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.length = e.length;
  }

  handleInput(event) {
    if (event.which === 32 && !this.Attribute.value.name.length)
      event.preventDefault();
  }
}
